import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface IGetGLAccountsData {
  id: number,
  trx_type: string,
  code_type: string,
  area_id: string,
  pool_id: string,
  department: string,
  code_segment: string,
  company_code: string,
  company_relation: string,
  trx_code: string,
  trx_desc: string,
  sap_bktxt: string,
  gnlldr: string,
  is_active: boolean,
  create_at: string,
  create_by: string,
  update_at: string,
  update_by: string,
}
export interface IGetGLAccountsResponse {
  lstsmplmsttrxcodeset: IGetGLAccountsData[];
}

export const url = "/v1/smplmsttrxcodeset";

export const getGLAccountsWithRelation = async (
  trxType: string,
  codeType: string,
  areaId: string,
  poolId: string,
  department: string,
  companyCode: string,
  segmentCode: string,
  companyRelation: string,
): Promise<IGetGLAccountsResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/trxtype/${trxType}/codetype/${codeType}/areaid/${areaId}/poolid/${poolId}/department/${department}/companycode/${companyCode}/codesegment/${segmentCode}/isactive/true/companyrelation/${companyRelation}`,
    method: "GET",
  });

  return data;
};

export const getGLAccounts = async (
  trxType: string,
  codeType: string,
  areaId: string,
  poolId: string,
  department: string,
  companyCode: string,
  segmentCode: string,
): Promise<IGetGLAccountsResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/trxtype/${trxType}/codetype/${codeType}/areaid/${areaId}/poolid/${poolId}/department/${department}/companycode/${companyCode}/codesegment/${segmentCode}/isactive/true`,
    method: "GET",
  });

  return data;
};
